import React from 'react'
import j from "../../logo.png"
import jss from "../../images/Screenshot.png"
import crypto1 from "../../images/Screenshot crypto1.png"
import crypto2 from "../../images/Screenshot crypto2.png"
import crypto3 from "../../images/Screenshot crypto3.png"
import Button from '../Button'
import { NavLink, Link } from "react-router-dom"
import {  CardActionArea, CardActions, Card, CardContent, CardMedia, Typography, Grid,Divider } from '@material-ui/core';


const Portfolio = () => {
    return (
        <div>
            <div class="card bg-gray-900 text-white">

                <div class="card-body">
                    <h5 class="card-title">Projects</h5>
                    <p class="card-text">With supporting text below as a natural lead-in to additional content.</p>
                    <Link to='/Project'>
                        <button  type="button" class="btn1 btn-success ">Projects</button>
                    </Link>
                </div>
            </div>
            <Grid container   className=" mt-20 " style={{display: 'flex' , flexDirection: 'row-reverse'}}>
                <Grid item xs={8}>
                    <img src={crypto3} class="" alt="..." style={{height: '300px', width: '98%'}}/>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant='h6' className='font-bold' >Home-Page</Typography>
                </Grid>
            </Grid>
            <Grid container   className=" mt-20" style={{display: 'flex' , flexDirection: 'row'}}>
                <Grid item xs={8}>
                    <img src={crypto2} class="" alt="..." style={{height: '300px', width: '98%'}}/>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant='h6' className='font-bold' >Exchange</Typography>
                </Grid>
            </Grid>
            <Grid container   className=" mt-20 mb-20" style={{display: 'flex' , flexDirection: 'row-reverse'}}>
                <Grid item xs={8}>
                    <img src={crypto1} class="" alt="..." style={{height: '300px', width: '98%'}}/>
                </Grid>
                <Grid item xs={4}>
                    <Typography variant='h6' className='font-bold' >Details</Typography>
                </Grid>
            </Grid>
            <Divider/>
        </div>
    )
}

export default Portfolio
